

import { useContext, useEffect, useRef, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';
import { UsersContext } from '../../context/users/UserContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { BanksContext } from '../../context/bank/BankContext';
import Message from '../../components/ui/Message';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { LinkPagoContext } from '../../context/linkPago/LinkPagoContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';





export const LinkPagoAdmin = () => {

    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const { createLinkPago, isLoading, loadLinksPago: loadLinksPago } = useContext(LinkPagoContext);


    const linkPago = {
        monto: '',
        descripcion: '',
        fechaVencimiento: '',
        nombreCliente: '',
        referencia: '',
        codigoPais: '+506',
        telefonoCliente: '',
        emailCliente: '',
        currency: 'CRC'
    };

    const { formState, onInputChange } = useForm(linkPago);

    const { monto, descripcion, nombreCliente, referencia, codigoPais, telefonoCliente, emailCliente, currency } = formState;

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhone = (phone: string) => /^\d{7,15}$/.test(phone);

    useEffect(() => {
        if (!fechaVencimiento)
            setFechaVencimiento(moment().add(1, 'day').format("YYYY-MM-DD"))



    }, [])

    // El cliente se contacta por correo o por teléfono: al menos uno es obligatorio
    const email = (emailCliente ?? '').trim();
    const phone = (telefonoCliente ?? '').replace(/[\s-]/g, '');
    const hasContact = email.length > 0 || phone.length > 0;
    const emailInvalid = !hasContact || (email.length > 0 && !isValidEmail(email));
    const phoneInvalid = !hasContact || (phone.length > 0 && !isValidPhone(phone));

    const handleSave = async () => {
        if (
            !monto ||
            !descripcion ||
            !fechaVencimiento ||
            !nombreCliente ||
            !referencia ||
            !currency
        ) {
            required.fail();
            setErrorMessage("Debe completar todos los campos requeridos.");
            return;
        }

        if (!hasContact) {
            required.fail();
            setErrorMessage("Debe ingresar el correo o el teléfono del cliente.");
            return;
        }

        if (email && !isValidEmail(email)) {
            required.fail();
            setErrorMessage("Debe ingresar un correo válido.");
            return;
        }

        if (phone && !isValidPhone(phone)) {
            required.fail();
            setErrorMessage("Debe ingresar un teléfono válido (solo números).");
            return;
        }

        const link = {
            monto,
            descripcion,
            fechaVencimiento: fechaVencimiento + 'T23:59:59',
            nombreCliente,
            referencia,
            telefonoCliente: phone ? (codigoPais || '+506') + phone : '',
            emailCliente: email,
            currency
        }

        const resp = await createLinkPago(link)

        if (resp == "success") {
            setSuccessMessage("Link de pago creado correctamente.");
        } else {
            setErrorMessage("Error al crear el link de pago.");
        }
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        reloadAndBack();
    }

    const reloadAndBack = () => {
        navigate(-1);
        var req = {
            "FechaInicio": moment().format("YYYY-MM-DD"),
            "FechaFin": moment().add(1, 'day').format("YYYY-MM-DD")
        }
        loadLinksPago(req);
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const handleCallback = (start) => {
        setFechaVencimiento(start.format('YYYY-MM-DD'));

    }

    return (
        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>
            <div className='col-md-6'>
                <h3>Crear Link de Pago</h3>
                <hr />

                <div className="mb-3">
                    <label htmlFor="lpNombreCliente" className="form-label">Nombre del cliente *</label>
                    <input
                        id="lpNombreCliente"
                        type="text"
                        className={`form-control${required.mark(!nombreCliente)}`}
                        placeholder="Nombre del cliente"
                        name="nombreCliente"
                        value={nombreCliente}
                        onChange={onInputChange}
                        required
                    />
                    <div className="invalid-feedback">Campo requerido</div>
                </div>

                <div className="mb-3">
                    <label htmlFor="lpEmailCliente" className="form-label">Correo del cliente</label>
                    <input
                        id="lpEmailCliente"
                        type="email"
                        className={`form-control${required.mark(emailInvalid)}`}
                        placeholder="Correo del cliente"
                        name="emailCliente"
                        value={emailCliente}
                        onChange={onInputChange}
                    />
                    <div className="invalid-feedback">{email ? 'Ingrese un correo válido' : 'Ingrese el correo o el teléfono'}</div>
                </div>

                <div className="mb-3">
                    <label htmlFor="lpTelefonoCliente" className="form-label">Teléfono del cliente (celular)</label>
                    <div className="input-group has-validation">
                        <select className="form-select" name="codigoPais" style={{ maxWidth: '160px' }}
                            value={codigoPais || '+506'}
                            onChange={onInputChange} aria-label="Código de país" >
                            <option value="+506">🇨🇷 +506 (Costa Rica)</option>
                            <option value="+1">🇺🇸/🇨🇦 +1 (EE. UU. / Canadá / Caribe)</option>
                            <option value="+52">🇲🇽 +52 (México)</option>
                            <option value="+501">🇧🇿 +501 (Belice)</option>
                            <option value="+502">🇬🇹 +502 (Guatemala)</option>
                            <option value="+503">🇸🇻 +503 (El Salvador)</option>
                            <option value="+504">🇭🇳 +504 (Honduras)</option>
                            <option value="+505">🇳🇮 +505 (Nicaragua)</option>
                            <option value="+507">🇵🇦 +507 (Panamá)</option>
                            <option value="+509">🇭🇹 +509 (Haití)</option>
                            <option value="+51">🇵🇪 +51 (Perú)</option>
                            <option value="+54">🇦🇷 +54 (Argentina)</option>
                            <option value="+55">🇧🇷 +55 (Brasil)</option>
                            <option value="+56">🇨🇱 +56 (Chile)</option>
                            <option value="+57">🇨🇴 +57 (Colombia)</option>
                            <option value="+58">🇻🇪 +58 (Venezuela)</option>
                            <option value="+591">🇧🇴 +591 (Bolivia)</option>
                            <option value="+592">🇬🇾 +592 (Guyana)</option>
                            <option value="+593">🇪🇨 +593 (Ecuador)</option>
                            <option value="+594">🇬🇫 +594 (Guayana Francesa)</option>
                            <option value="+595">🇵🇾 +595 (Paraguay)</option>
                            <option value="+596">🇲🇶 +596 (Martinica)</option>
                            <option value="+597">🇸🇷 +597 (Surinam)</option>
                            <option value="+598">🇺🇾 +598 (Uruguay)</option>
                            <option value="+876">🇯🇲 +876 (Jamaica)</option>
                            <option value="+53">🇨🇺 +53 (Cuba)</option>
                            <option value="+1">🇩🇴/🇵🇷 +1 (República Dominicana / Puerto Rico)</option>
                            <option value="+34">🇪🇸 +34 (España)</option>
                            <option value="+49">🇩🇪 +49 (Alemania)</option>
                            <option value="+33">🇫🇷 +33 (Francia)</option>
                            <option value="+44">🇬🇧 +44 (Reino Unido)</option>
                            <option value="+39">🇮🇹 +39 (Italia)</option>
                            <option value="+31">🇳🇱 +31 (Países Bajos)</option>
                            <option value="+41">🇨🇭 +41 (Suiza)</option>
                            <option value="+46">🇸🇪 +46 (Suecia)</option>
                            <option value="+47">🇳🇴 +47 (Noruega)</option>
                            <option value="+45">🇩🇰 +45 (Dinamarca)</option>
                            <option value="+48">🇵🇱 +48 (Polonia)</option>
                            <option value="+351">🇵🇹 +351 (Portugal)</option>
                            <option value="+353">🇮🇪 +353 (Irlanda)</option>
                            <option value="+32">🇧🇪 +32 (Bélgica)</option>
                            <option value="+43">🇦🇹 +43 (Austria)</option>

                        </select>
                        <input id="lpTelefonoCliente" type="text" inputMode="tel" className={`form-control${required.mark(phoneInvalid)}`}
                            placeholder="Número local (ej: 88998877)" name="telefonoCliente" value={telefonoCliente || ''} onChange={onInputChange} />
                        <div className="invalid-feedback">{phone ? 'Ingrese un teléfono válido (solo números)' : 'Ingrese el correo o el teléfono'}</div>
                    </div>
                    <div className="form-text">Ingrese al menos el correo o el teléfono del cliente.</div>

                </div>

                <form className="row g-3">

                    <div className="mb-3">
                        <label className="form-label">Fecha de vencimiento *</label>
                        <DateRangePicker
                            onCallback={handleCallback}
                            initialSettings={{
                                singleDatePicker: true,
                                showDropdowns: false,
                                showCalendars: false,
                                autoApply: true,
                                locale: {
                                    cancelLabel: 'Cancelar',
                                    applyLabel: 'Aplicar',
                                    customRangeLabel: 'Selecciona fecha',
                                },
                                startDate: moment().add(1, 'day'),
                                minDate: moment(),
                                maxDate: moment().add('2', 'days'),
                                ranges: {

                                }
                            }}
                        >
                            <input type="text" className="form-control" />
                        </DateRangePicker>

                    </div>

                    <div className="mb-3">
                        <label htmlFor="lpMonto" className="form-label">Monto *</label>
                        <input
                        id="lpMonto"
                            type="number"
                            className={`form-control${required.mark(!monto)}`}
                            placeholder="Monto"
                            name="monto"
                            value={monto}
                            min={0}
                            onChange={onInputChange}
                            onWheel={(e) => {
                                e.currentTarget.blur()
                            }}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Moneda</label>
                        <select
                            className="form-select"
                            name="currency"
                            value={currency}
                            onChange={onInputChange}
                            required
                        >
                            <option value="CRC">Colones (CRC)</option>
                            <option value="USD">Dólares (USD)</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="lpReferencia" className="form-label">Referencia *</label>
                        <input
                        id="lpReferencia"
                            type="text"
                            className={`form-control${required.mark(!referencia)}`}
                            placeholder="Referencia (ej: PED-8429)"
                            name="referencia"
                            value={referencia}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="lpDescripcion" className="form-label">Descripción *</label>
                        <input
                        id="lpDescripcion"
                            type="text"
                            className={`form-control${required.mark(!descripcion)}`}
                            placeholder="Descripción"
                            name="descripcion"
                            value={descripcion}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>









                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => reloadAndBack()} className="btn btn-outline-secondary">Atrás</button>
                        {/* <button type="button" onClick={handleSave} className="btn btn-primary ms-5">Guardar</button> */}
                        {isLoading ? (
                            <button className="btn btn-primary ms-5" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span className="visually-hidden">Loading...</span>
                            </button>
                        ) : (
                            <button type="button" onClick={handleSave} className="btn btn-primary ms-5">
                                Enviar
                            </button>
                        )}
                    </div>
                </form>

                <div style={{ height: '100px' }}></div>
            </div >

            {
                errorMessage.length > 0 &&
                <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' />
            }

            {
                successMessage.length > 0 &&
                <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' />
            }
        </div >
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
